<template>
  <svg :width="size" :height="size" viewBox="0 0 36 36" aria-hidden="true">
    <circle cx="18" cy="18" r="17" :fill="faceColor" />
    <path
      v-if="level === MOOD_LEVEL.VERY_LOW"
      d="M9.5 11l5 1.8M26.5 11l-5 1.8"
      stroke="var(--face-ink)"
      stroke-width="1.7"
      stroke-linecap="round"
    />
    <circle cx="12.5" cy="15.5" r="1.9" fill="var(--face-ink)" />
    <circle cx="23.5" cy="15.5" r="1.9" fill="var(--face-ink)" />
    <path
      :d="mouth"
      :fill="level === MOOD_LEVEL.GREAT ? 'var(--face-ink)' : 'none'"
      stroke="var(--face-ink)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script setup>
// 1. Import necessary components
import { computed } from 'vue';
import { MOOD_LEVEL, MOOD_OPTIONS } from '../constants/symptom';
// 2. Use
const props = defineProps({
  level: { type: Number, required: true },
  size: { type: Number, default: 38 },
});
// 3. Define a reactive variable
// Mouth path per mood level, from Very low (1) to Great (5).
const MOUTHS = Object.freeze([
  'M12 26.5q6-6.5 12 0',
  'M13 25.5q5-4.5 10 0',
  'M13 24.5h10',
  'M12 22q6 5.5 12 0',
  'M11 21q7 9.5 14 0z',
]);
// 4. Define methods or computed properties if needed
const faceColor = computed(() => MOOD_OPTIONS.find((option) => option.value === props.level)?.face);
const mouth = computed(() => MOUTHS[props.level - 1]);
// 5. VueJS Hooks
</script>
